import { render, staticRenderFns } from "./ContentPacks.vue?vue&type=template&id=7885751e&scoped=true&"
import script from "./ContentPacks.vue?vue&type=script&lang=js&"
export * from "./ContentPacks.vue?vue&type=script&lang=js&"
import style0 from "./ContentPacks.vue?vue&type=style&index=0&id=7885751e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7885751e",
  null
  
)

export default component.exports